import React, { useEffect } from "react";
import "../Footer/Footer.css";
import { Link } from "react-router-dom";
import { FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
// import gmail from "../Assets/gmail.png";
// import linkedin from "../Assets/linkedin.png";
// import instagram from "../Assets/instagram.png";
// import twitter from "../Assets/twitter.png";

function Footer() {
  useEffect(() => {
    var n = new Date();
    var y = n.getFullYear();
    document.getElementById("date").innerHTML = y;
  });
  return (
    <>
      <div className="footer">
        <div className="footer-row1">
          <div className="footer-div1">
            <h1>Medisol Lab</h1>
            {/* <p className="slogan">Breather for Life</p> */}
            <div className="footer-social">
              <Link to={"https://x.com/i/flow/login"} className="social-icons">
                <FaXTwitter />
                {/* <img src={twitter} alt="gmail-icon"/> */}
              </Link>
              <Link
                to={"https://mail.google.com/mail"}
                className="social-icons"
              >
                <IoMdMail />
                {/* <img src={gmail} alt="gmail-icon"/> */}
              </Link>
              <Link
                to={
                  "https://www.linkedin.com/login?fromSignIn=true&trk=guest_homepage-basic_nav-header-signin"
                }
                className="social-icons"
              >
                <FaLinkedinIn />
                {/* <img src={linkedin} alt="linkedin-icon"/> */}
              </Link>
              <Link
                to={"https://www.instagram.com/accounts/login/"}
                className="social-icons"
              >
                <FaInstagram />
                {/* <img src={instagram} alt="linkedin-icon"/> */}
              </Link>
            </div>
          </div>

          <div className="footer-right-top">
            <div className="footer-menu-div">
              {/* <h2>Company</h2> */}
              <Link to="/" className="footer-menu">
                Home
              </Link>
              <Link to="/services" className="footer-menu">
                Services
              </Link>
              <Link to="/contactus" className="footer-menu">
                Contact
              </Link>
            </div>
            <div className="footer-right-bottom">
              <div>
                <h3>Head Office</h3>
                <p>
                  228, Pragati Industrial Estate,
                  <br /> N. M. Joshi Marg, Lower Parel (E)
                  <br /> Mumbai, 400 011, India
                </p>
              </div>
              <div>
                <h3>Corporate Office</h3>
                <p>
                  1417, Make Chamber V, Nariman Point,
                  <br /> Mumbai 400 021, India Tel:91-22-69074440
                  <br /> Email: medisol@asianitg.com
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-row2">
          <p>
            Medisol Lifescience Pvt. Ltd © Copyright <span id="date"></span>,
            All Right Reserved
          </p>
        </div>
      </div>
    </>
  );
}
export default Footer;
